import { mapState } from 'vuex';
export default {
    data() {
        return {
            message: '',
            dismissSecs: 5,
            dismissCountDown: 0,
            showDismissibleAlert: false,
        }
    },
    computed: {
        ...mapState({
            token: state => state.token
        }),
        isEditing() {
            return Boolean(this.$route.params.id);
        }
    }
}